import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailTellentLogoComponent } from '../../components/email-tellent-logo/email-tellent-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { TellentProductsFooterComponent } from '../../components/tellent-products-footer/tellent-products-footer.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  standalone: true,
  styleUrls: ['../../global-styles.less', './tellent-verify-email.component.less'],
  templateUrl: './tellent-verify-email.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
    EmailTellentLogoComponent,
    TellentProductsFooterComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class TellentVerifyEmailTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<TellentVerifyEmailTemplateData>;
}

export type TellentVerifyEmailTemplateData = {
  avatar_url: string;
  header: string;
  subheader_html: string;
  p1_html: string;
  p2: string;
  p3: string;
  footer: {
    text: string;
    label: string;
    href: string;
  };
  primary_cta: {
    href: string;
    label: string;
  };
};

export const TellentVerifyEmailTemplateMocks: TellentVerifyEmailTemplateData[] = [
  {
    avatar_url:
      'https://recruitee-staging.s3.eu-central-1.amazonaws.com/admins/45690/thumb_avatar_hcwhs58oldbe.jpg',
    header: 'Verify your email address',
    subheader_html: `Hello %{user_name}! 👋 Please verify the new email address for your Tellent account.`,
    p1_html: `Current email: <a href='%{current_email}'>%{current_email}</a><br />New email: <a href='%{new_email}'>%{new_email}</a>`,
    p2: 'If you don’t want to change your email address, simply ignore this email.',
    p3: 'If this change hasn’t been made by you or someone from your team, please contact our support.',
    footer: {
      text: 'Need help?',
      href: 'support@tellent.com',
      label: 'Contact us',
    },
    primary_cta: {
      href: 'https://tellent.com',
      label: 'Verify new email address',
    },
  },
];
